import RtChartWrapper from "./rt-chart-wrapper"

const Rt = {
  RtChartWrapper,
}

export default Rt